import { allBreakpoints, Breakpoint, breakpointValues } from './Breakpoints';
/**
 * Finds the nearest breakpoint from the list of all available breakpoints that matches the backend list.
 * If the current breakpointId is in the backend breakpoints, it returns the breakpointId.
 * Otherwise, it first checks the larger breakpoints, and if no match is found, checks the smaller breakpoints.
 *
 * @param {Breakpoint} breakpointId - The current breakpointId.
 * @param {string[]} backendBreakpoints - The list of breakpoints from the backend.
 * @param {string[]} allBreakpoints - The list of all available breakpoints.
 *
 * @returns {string} - The nearest breakpoint in the larger direction that matches the backend list, or the nearest breakpoint in the smaller direction if no larger breakpoint is found.
 */
function getNearestBreakpoint(breakpointId, breakpointList) {
  if (breakpointList.includes(breakpointId)) {
    return breakpointId;
  }
  const breakpointIndex = allBreakpoints.indexOf(breakpointId);

  // Check larger breakpoints
  for (let i = breakpointIndex + 1; i < allBreakpoints.length; i++) {
    if (breakpointList.includes(allBreakpoints[i])) {
      return allBreakpoints[i];
    }
  }

  // Check smaller breakpoints
  for (let i = breakpointIndex - 1; i >= 0; i--) {
    if (breakpointList.includes(allBreakpoints[i])) {
      return allBreakpoints[i];
    }
  }

  // This error should never be thrown because a breakpoint will always be found
  throw new Error('No matching breakpoint found');
}
export function mapResponsiveBreakpointToScreenSize(breakpoint, breakpointList) {
  if (breakpoint < breakpointValues.sm) {
    return getNearestBreakpoint(Breakpoint.sm, breakpointList);
  } else if (breakpoint < breakpointValues.md && breakpoint >= breakpointValues.sm) {
    return getNearestBreakpoint(Breakpoint.md, breakpointList);
  } else {
    return getNearestBreakpoint(Breakpoint.lg, breakpointList);
  }
}